module.exports = __webpack_public_path__ + "static/media/twitter-icon.7756a837.svg";